module.exports = __webpack_public_path__ + "img/quest_selector_2.87915b9f.png";